import VerticalSlider from 'javascripts/utils/VerticalSlider';

document
  .querySelectorAll('.messages-slider')
  .forEach(($el) => {
    const $box = $el;
    const $content = $el.querySelector('.messages-slider__content');
    const $grid = $el.closest('.grid__row');

    if ($grid) {
      const gridHeight = $grid.getBoundingClientRect().height;
      const putHeight = Math.max(gridHeight, 500);
      $box.style.maxHeight = `${putHeight}px`;
    }

    return new VerticalSlider($content);
  });
